import $ from 'jquery';
import { trapFocus, releaseFocus } from '../../common/js/modalA11y';
 
const trackComplaint = {
    methods : {
        validateFields : function(ele){
            const inputs = $(ele).find('.track-complaint__group--input');
            inputs.each(function(){
                $(this).on('input', function(){
                    $(this).siblings('.empty-error').addClass('opacity-0');
                    $(this).removeClass('border-red-300');
                    $(ele).find('.track-complaint__one-field--error').addClass('opacity-0');
                    const regex = new RegExp("^[A-Z0-9-]+$");
                    if(regex){
                        if(regex.test($(this).val())){
                            $(this).siblings('.invalid-error').addClass('opacity-0');
                            $(this).removeClass('border-red-300');
                        }else{
                            $(this).siblings('.invalid-error').removeClass('opacity-0');
                            $(this).addClass('border-red-300');
                        }
                    }
                    if($(this).val() == ''){
                        $(this).siblings('.invalid-error').addClass('opacity-0');
                        $(this).removeClass('border-red-300');
                    }
                });
            });
            const consentStatus = $(ele).find('.track-complaint__consent--input');
            consentStatus.on('input',function(e){
                $(this).addClass('border-blue-400').removeClass('border-red-300');
                $(this).siblings('.track-complaint__consent--error').addClass('opacity-0');
                if($(this).prop('required') && !$(this).is(':checked')){
                    $(this).removeClass('border-blue-400').addClass('border-red-300');
                    $(this).siblings('.track-complaint__consent--error').removeClass('opacity-0');
                }
            })
        },
        getFirstWord : function(str) {
            if(!str){
                return '';
            }
            let words = str.split(' ');
            return words[0];
        },
        handleSubmit : function(ele){
            const form = $(ele).find('.track-complaint__questions--form');
            $(form).on('submit', async function(e){
                e.preventDefault();
                const applicationNumber = $(this).find('.application').find('.track-complaint__group--input').val();
                const complaintId = $(this).find('.complaint').find('.track-complaint__group--input').val();
                let isFormValid = true;
                const consentCheckbox = $(this).find('.track-complaint__consent--input'),
                    consentError = $(this).find('.track-complaint__consent--error');
                if(!complaintId){
                    $(this).find('.track-complaint__one-field--error').removeClass('opacity-0');
                    isFormValid = false;
                }else{
                    $(this).find('.track-complaint__one-field--error').addClass('opacity-0');
                }
                const inputs = $(this).find('.track-complaint__input--id');
                inputs.each(function(){
                    if($(this).hasClass('border-red-300')){
                        isFormValid = false;
                        return;
                    }
                });
                if(consentCheckbox.prop('required') && !consentCheckbox.is(':checked')){
                    isFormValid = false;
                    consentCheckbox.siblings('.track-complaint__consent--checkbox').removeClass('border-blue-400').addClass('border-red-300');
                    consentError.removeClass('opacity-0');
                }
                if(isFormValid){
                    trackComplaint.methods.handleLoader(ele, true);
                    trackComplaint.methods.handleRequest(form,applicationNumber,complaintId,ele);
                }
            });
        },
        handleRequest : function(form,applicationNumber,complaintId,ele){
            const url = '/bin/chli/trackComplaint';
            let json = {
                'ApplicationNo' : applicationNumber,
                'TicketNo' : complaintId
            }
            json = JSON.stringify(json);
            $.ajax({
                type: "POST",
                url: url,
                data: json,
                contentType: "application/json",
                dataType: "json",
            }).done((response) => {
                trackComplaint.methods.handleLoader(ele, false);
                trackComplaint.methods.handleResponseModal(response,ele);
            }).catch((error) => {
                console.error(error);
                trackComplaint.methods.handleLoader(ele, false);
            });
        },
        handleResponseModal : function(response, ele){
            const parentContainer = $(ele);
            const dstResponseContainer = parentContainer.find('.track-response');
            const labelDescription = dstResponseContainer.find('.track-response__box').find('div');
            labelDescription.find('div').addClass('d-none');
            if(Object.keys(response).length <= 0){
                labelDescription.find('div.invalid-case').removeClass('d-none');
                labelDescription.find('div.bottom-border').removeClass('d-none');
            }else{
                const resultObject = response.caseData[response.caseData.length-1];
                const caseStatus = resultObject.CaseStageStatus;
                const caseType = resultObject.CaseTypeCode;
                const processType = resultObject.ProcessType;
                labelDescription.find('div.bottom-border').removeClass('d-none');
                if(processType != 'CRU' && processType != 'IRDA') {
                  labelDescription.find('div.invalid-case').removeClass('d-none');
                }
               else if(caseStatus == 'Pending'){
                    labelDescription.find('div.pending').removeClass('d-none');
                }
                else if(caseStatus == 'New'){
                    labelDescription.find('div.pending').removeClass('d-none');
                }
                else if(caseStatus == 'Acknowledged'){
                    labelDescription.find('div.pending').removeClass('d-none');
                }
               else if(caseStatus == 'WIP'){
                    labelDescription.find('div.pending').removeClass('d-none');
               }
               else  if(caseStatus == 'Closed' && caseType == 'Query'){
                    labelDescription.find('div.closed-query').removeClass('d-none');
               }
               else if(caseStatus == 'Closed' && caseType == 'Complex Query'){
                    let resolutionDate = trackComplaint.methods.getFirstWord(resultObject.ResolutionDate || resultObject.ClosureDate);
                    labelDescription.find('div.closed-complex').removeClass('d-none');
                    labelDescription.find('div.solution').find('span').text(resultObject.SolutoinInformation || '');
                    labelDescription.find('div.date-closure').find('span').text(resolutionDate);
               }
               else if(caseStatus == 'Closed' && caseType == 'Complaint'){
                    let resolutionDate = trackComplaint.methods.getFirstWord(resultObject.ResolutionDate || resultObject.ClosureDate);
                    labelDescription.find('div.closed-complex').removeClass('d-none');
                    labelDescription.find('div.solution').find('span').text(resultObject.SolutoinInformation || '');
                    labelDescription.find('div.date-closure').find('span').text(resolutionDate);
               }
               else if(caseStatus == 'Attended To' && caseType == 'Complaint'){
                    let resolutionDate = trackComplaint.methods.getFirstWord(resultObject.ResolutionDate || resultObject.ClosureDate);
                    labelDescription.find('div.closed-complex').removeClass('d-none');
                    labelDescription.find('div.solution').find('span').text(resultObject.SolutoinInformation || '');
                    labelDescription.find('div.date-closure').find('span').text(resolutionDate);
               }
            }
            $('body').append(dstResponseContainer);
            $(dstResponseContainer).removeClass('d-none').addClass('inside-body-track-response');
            $('body').addClass('overflow-hidden');
            trapFocus($(dstResponseContainer));
        },
        handleLoader : function(loader, isAdd){
            const parentLoad = $(loader).find('.spinning-loader');
            if(isAdd){
                $('body').append(parentLoad); // Move the loader to the body
                $(parentLoad).removeClass('d-none').addClass('inside-body-loader-request'); // Show the loader
                $('body').css('overflow', 'hidden'); // Prevent body scrolling
            }else{
                //$(loader).addClass('d-none'); // Hide the loader
                $('body').css('overflow', ''); // Restore body scrolling
                const loaderBody = $('body').find('.inside-body-loader-request');
                $(loader).append($(loaderBody).removeClass('inside-body-loader-request').addClass('d-none'));
            }
        },
        closeTrackResponse : function(ele){
            var trackResponse = $('body').find('.inside-body-track-response');
            if (trackResponse.length) {
                trackResponse.addClass('d-none');
                $('body').removeClass('overflow-hidden');
                $('body').css('overflow', '');
                $(ele).append(trackResponse.removeClass('inside-body-track-response').addClass('d-none'));
                releaseFocus();
            }
        },
        handleCloseModal : function(ele){
            const closeIcon = $(ele).find('.track-response__close--icon');
            closeIcon.each(function(){
                $(this).on('click', function(){
                    trackComplaint.methods.closeTrackResponse(ele);
                });
            });
            const closeContainer = $(ele).find('.track-response__close');
            closeContainer.each(function(){
                 $(this).on('click', function(){
                     trackComplaint.methods.closeTrackResponse(ele);
                 });
            });

            // Escape key to close response modal (WCAG 2.1.2)
            $(document).on('keydown', function(e){
                if (e.key === 'Escape' && $('body').find('.inside-body-track-response').not('.d-none').length) {
                    e.preventDefault();
                    trackComplaint.methods.closeTrackResponse(ele);
                }
            });
        },
        init : function(){
            $('.track-complaint').each((idx,ele)=>{
                trackComplaint.methods.validateFields(ele);
                trackComplaint.methods.handleSubmit(ele);
                trackComplaint.methods.handleCloseModal(ele);
            })
        }
    }
}
 
$(()=>{
    if($('.track-complaint').length > 0){
        trackComplaint.methods.init();
    }
})